import { HttpContext, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map, Observable, Subject, throwError } from 'rxjs';

import { ClockingDto } from '@app/data/dtos/mot/clocking/clocking.dto';
import { mapClocking } from '@app/data/mappers/mot/clocking.mapper';
import { ClockingRepository as ClockingRepository } from '@app/domain/repositories/mot/clocking.repository.contract';
import { ErrorMsgEnum } from '@app/entities/enums/error/error-msg-enum';
import { ErrorCodes } from '@app/entities/models/error/error.model';
import { Clocking } from '@app/entities/models/mot/clocking/clocking.model';
import { Logger } from '@app/services';
import { toLocalISO } from '@app/shared/utils/date-utils';
import { ENV } from '@environments/environment';
import { SECTION_KEY } from '@services/interceptors/error-sections.interceptor/error-sections.interceptor';

import { MRepository } from '@mercadona/core/utils/repository';

@Injectable({
  providedIn: 'root'
})
export class ClockingRepositoryImpl extends MRepository implements ClockingRepository {
  private logger = new Logger('MotService');
  private onError = new Subject<ErrorMsgEnum>();
  onError$ = this.onError.asObservable();
  private readonly clockingUrl = '/timemanage/v1/clockings';

  constructor() {
    super(`${ENV.API_URL_MOT}`);
  }

  getClockings(): Observable<Clocking> {
    const datetime = toLocalISO(new Date());
    const params = new HttpParams().set('datetime', datetime);

    return this.get<ClockingDto>(this.clockingUrl, {
      params,
      context: new HttpContext().set(SECTION_KEY, 'clocking')
    }).pipe(
      map(mapClocking),
      catchError((error: HttpErrorResponse) => {
        const errorType =
          error && error.status === ErrorCodes.LOCKED ? ErrorMsgEnum.SERVICE_LOCKED : ErrorMsgEnum.SERVER_ERROR;
        this.onError.next(errorType);
        this.logger.error(error);

        return throwError(() => error);
      })
    );
  }
}
